module.exports = __webpack_public_path__ + "img/login-muyullacta.70f03415.svg";